import "../../../lib/store/createAppApi.js";
import "../../../lib/store/createAppAsyncThunk.js";
import "../../../lib/store/createAppSelector.js";
import { createAppSlice } from "../../../lib/store/createAppSlice.js";
import "react";
import "redux";
import "../../../lib/store/hooks/useAppDispatch.js";
import "../../../lib/store/hooks/useAppSelector.js";
import "../../../lib/store/hooks/useAppStore.js";
import { name } from "../config/name.js";
const initialState = {
  offset: 0,
  limit: 12
};
const slice = createAppSlice({
  name,
  initialState,
  reducers: {
    reset: () => initialState,
    setOffset: (state, action) => {
      state.offset = action.payload;
    },
    setLimit: (state, action) => {
      state.limit = action.payload;
      state.offset = 0;
    }
  }
});
const { reducer, actions, reducerPath } = slice;
export {
  actions,
  reducer,
  reducerPath,
  slice
};
